import * as Paths from './paths';
import * as pathUtils from './utils';

export default Paths;
export { pathUtils };
